import { Controller, useFormContext } from 'react-hook-form';
import DateRangePicker from './date-range-picker';
import 'react-datepicker/dist/react-datepicker.css';

function FormDateRangePicker({ name, label, required = true, errorMessage = '', key }: any) {
  const {
    control,
    formState: { errors },
    watch,
  } = useFormContext();

  // Debug: Log the errors to check if validation is happening

  return (
    <div>
      <Controller
        name={name}
        control={control}
        rules={{
          required: required ? `${label} is required` : false, // Apply required validation if `required` is true
        }}
        render={({ field }) => (
          <DateRangePicker
            label={label}
            defaultValue={field.value}
            onChange={(dates: [Date | null, Date | null]) => {
              // Ensure the value passed to field.onChange is in the correct format
              field?.onChange(dates); // Update react-hook-form state
            }}
          />
        )}
      />

      {/* Show error message if validation fails */}
      {!watch(name) && !!errors?.filters && <p style={{ color: 'red' }}>{`${label} is required`}</p>}
    </div>
  );
}

export default FormDateRangePicker;
